import axios from 'axios';
import useEmblaCarousel from 'embla-carousel-react';
import React, { useCallback, useEffect, useState } from 'react';
import { components } from '../components';
import { MAIN_URL } from '../config';
import { hooks } from '../hooks';
import { Routes } from '../routes';
import { getQueryParamValue } from '../utils/useQueryParam';
import { useWindowSize } from '../hooks/useWindowSize';




export const Onboarding: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const [opacity, setOpacity] = useState<number>(0);
  const [noQRData, setNoQRData] = useState(false);
  const [logoUrl, setLogoUrl] = useState("")
  const { width: windowWidth } = useWindowSize();
  const onboarding = [
    {
      id: 1,
      title1: 'Explore a World of',
      title2: 'Delicious Options',
      image: logoUrl,
      descriptionLine1: 'From local favorites to chef specials,',
      descriptionLine2: 'find something for every craving.',
    },
    {
      id: 2,
      title1: 'Order with Ease,',
      title2: 'Enjoy with Joy',
      image: 'https://george-fx.github.io/dinehub_api/assets/images/06.jpg',
      descriptionLine1: 'Browse the menu, customize dishes,',
      descriptionLine2: 'and place orders in seconds.',
    }
  ]
  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const dataParam = sessionStorage.getItem('dataParam') || getQueryParamValue('data');
  const [activeIndex, setActiveIndex] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel();

  const handleSlideChange = useCallback(() => {
    if (emblaApi) {
      setActiveIndex(emblaApi.selectedScrollSnap());
    }
  }, [emblaApi]);

  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('select', handleSlideChange);
    }
  }, [emblaApi, handleSlideChange]);

  

  useEffect(() => {
    if (dataParam) {
      sessionStorage.setItem('dataParam', dataParam);
    }
    if (!dataParam) {
      setNoQRData(true);
      return;
    }
    axios
      .post(MAIN_URL + "admin/get-table-details", { encTId: dataParam })
      .then((response) => {
        localStorage.setItem("REACT_APP_RESTAURANT_ID", response.data.tableRSID.rsId);
        localStorage.setItem("TABLE_ID", response.data.tableRSID.tId);
        const locationData = {
          lat: response.data.tableRSID.latitude,
          lon: response.data.tableRSID.longitude,
        };
        sessionStorage.setItem('locationData', JSON.stringify(locationData));
        setLogoUrl(response.data.tableRSID.logo)
      })
      .catch((error) => {
        sessionStorage.removeItem('dataParam');
        window.location.replace("/");
      });
  }, [dataParam]);

  const renderSlider = (): JSX.Element => {
    const isSmallScreen = windowWidth <= 375;
    const isMediumScreen = windowWidth <= 480;
    
    return (
      <div
        className="embla"
        ref={emblaRef}
        style={{
          position: 'relative',
          minHeight: isSmallScreen ? '240px' : isMediumScreen ? '280px' : '320px',
          maxHeight: isSmallScreen ? '320px' : isMediumScreen ? '360px' : '400px',
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          padding: isSmallScreen ? '15px 0' : '20px 0',
          marginTop: isSmallScreen ? '15px' : '20px',
        }}
      >
        <div className="embla__container" style={{ display: 'flex', width: '100%' }}>
          {onboarding.map((item) => (
            <div
              key={item.id}
              style={{
                width: '100%',
                cursor: 'pointer',
                flex: '0 0 100%',
                minWidth: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0 20px',
              }}
              className="embla__slide"
            >
              <div style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
              }}>
                <img
                  src={item.id === 1 ? logoUrl || "/menu1.png" : item.image}
                  alt={item.id === 1 ? "Restaurant Logo" : "Food Image"}
                  style={{
                    maxWidth: isSmallScreen ? '200px' : isMediumScreen ? '240px' : '280px',
                    width: isSmallScreen ? '70%' : isMediumScreen ? '65%' : '64%',
                    margin: '0 auto',
                    objectFit: 'contain',
                    borderRadius: item.id === 1 ? '20px' : '16px',
                    boxShadow: item.id === 1 
                      ? '0 8px 24px rgba(0, 176, 185, 0.15)' 
                      : '0 4px 12px rgba(0, 0, 0, 0.08)',
                    background: item.id === 1 ? 'rgba(255, 255, 255, 0.8)' : 'transparent',
                    padding: item.id === 1 ? '10px' : '0',
                    transition: 'transform 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.02)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderDots = (): JSX.Element => {
    const isSmallScreen = windowWidth <= 375;
    
    return (
      <section className="container center" style={{ 
        gap: 10, 
        marginBottom: isSmallScreen ? '6%' : '8%',
        padding: '20px 0 10px',
      }}>
        {onboarding.map((item, index) => {
          const isSelected = index === activeIndex;
          return (
            <div
              key={item.id}
              style={{
                backgroundColor: isSelected ? '#00B0B9' : 'rgba(0, 176, 185, 0.3)',
                width: isSelected ? 24 : 8,
                height: 8,
                borderRadius: 4,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: 'pointer',
                boxShadow: isSelected ? '0 2px 8px rgba(0, 176, 185, 0.4)' : 'none',
              }}
            />
          );
        })}
      </section>
    );
  };

  const renderDescription = (): JSX.Element => {
    const isSmallScreen = windowWidth <= 375;
    const isMediumScreen = windowWidth <= 480;
    
    return (
      <section className="container" style={{ margin: '20px 0' }}>
        <div
          style={{
            paddingLeft: isSmallScreen ? 20 : 24,
            paddingRight: isSmallScreen ? 20 : 24,
            paddingTop: isSmallScreen ? '24px' : isMediumScreen ? '28px' : '32px',
            paddingBottom: isSmallScreen ? '24px' : isMediumScreen ? '28px' : '32px',
            borderRadius: isSmallScreen ? 16 : 20,
            backgroundColor: 'var(--white-color)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 28px rgba(0, 0, 0, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.06)';
          }}
        >
          <h1
            style={{
              textAlign: 'center',
              marginBottom: isSmallScreen ? 16 : 20,
              marginTop: 0,
              lineHeight: 1.2,
              letterSpacing: '-0.5px',
            }}
          >
            <span style={{
              display: 'block',
              fontSize: isSmallScreen ? '26px' : isMediumScreen ? '28px' : '32px',
              fontFamily: 'DM Sans, sans-serif',
              fontWeight: 700,
              marginBottom: '4px',
              background: 'linear-gradient(135deg, var(--main-color) 0%, var(--main-turquoise) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              {onboarding[activeIndex].title1}
            </span>
            <span style={{
              display: 'block',
              fontSize: isSmallScreen ? '30px' : isMediumScreen ? '32px' : '36px',
              fontFamily: 'DM Sans, sans-serif',
              fontWeight: 800,
              color: 'var(--main-turquoise)',
            }}>
              {onboarding[activeIndex].title2}
            </span>
          </h1>
          <p className="t16" style={{ 
            textAlign: 'center',
            fontSize: isSmallScreen ? '14px' : '16px',
            lineHeight: 1.7,
            margin: 0,
            padding: '0 8px',
            color: 'var(--text-color)',
          }}>
            {onboarding[activeIndex].descriptionLine1} <br />
            {onboarding[activeIndex].descriptionLine2}
          </p>
        </div>
      </section>
    );
  };

  const renderButtons = (): JSX.Element => {
    const isSmallScreen = windowWidth <= 375;
    
    return (
      <section style={{ 
        padding: isSmallScreen ? '15px 16px 30px' : '20px 20px 40px',
        maxWidth: '100%',
      }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            alignItems: 'stretch',
            maxWidth: '100%',
          }}
        >
          <components.Button
            text="What Should I Eat?"
            onClick={() => {
              window.location.replace(Routes.QuestionFlow);
            }}
            colorScheme="secondary"
          />
          <components.Button
            text="Get Started"
            onClick={() => {
              window.location.replace(Routes.TabNavigator);
            }}
            colorScheme="primary"
          />
        </div>
      </section>
    );
  };

  // If no QR data is available, show a message prompting the user to scan the QR code.
  if (noQRData) {
    return (
      <div className="flex items-center justify-center h-screen bg-gradient-to-r from-[#f8ede3] to-[#f9dcc4]">
        <div className="bg-white p-10 rounded-2xl shadow-2xl text-center max-w-md mx-4">
          <svg 
            className="w-28 h-28 mx-auto text-[#6c584c]"
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 56 56"
            fill="currentColor"
          >
            <path d="M8.383 21.402c1.219 0 1.875-.68 1.875-1.922v-5.53c0-2.438 1.312-3.68 3.656-3.68h5.672c1.219 0 1.898-.68 1.898-1.899 0-1.195-.68-1.875-1.898-1.875h-5.742c-4.875 0-7.36 2.414-7.36 7.242v5.743c0 1.242.68 1.921 1.899 1.921m39.234 0c1.242 0 1.899-.68 1.899-1.922v-5.742c0-4.828-2.438-7.242-7.36-7.242h-5.719c-1.242 0-1.921.68-1.921 1.875 0 1.219.68 1.899 1.921 1.899h5.672c2.297 0 3.633 1.242 3.633 3.68v5.53c0 1.243.68 1.922 1.875 1.922m-20.625 4.57v-8.179c0-.562-.445-1.031-1.031-1.031h-8.156c-.586 0-1.032.468-1.032 1.031v8.18c0 .562.446 1.008 1.032 1.008h8.156c.586 0 1.031-.446 1.031-1.008m4.055-7.171h6.14v6.14h-6.14Zm4.36 4.36v-2.556h-2.555v2.555Zm-12.235 0v-2.556h-2.578v2.555Zm-4.36 7.898h6.141v6.14h-6.14Zm20.11.796v-2.554h-2.555v2.555Zm-7.055 0v-2.554h-2.555v2.555Zm-8.695 3.54V32.84h-2.578v2.554Zm12.234 0V32.84h-2.578v2.554Zm1.031 14.109h5.72c4.921 0 7.359-2.438 7.359-7.266V36.52c0-1.243-.68-1.922-1.899-1.922s-1.875.68-1.875 1.922v5.53c0 2.438-1.336 3.68-3.633 3.68h-5.672c-1.242 0-1.921.68-1.921 1.899 0 1.195.68 1.875 1.921 1.875m-22.593 0h5.742c1.219 0 1.898-.68 1.898-1.875 0-1.219-.68-1.898-1.898-1.898h-5.672c-2.344 0-3.656-1.243-3.656-3.68V36.52c0-1.243-.68-1.922-1.875-1.922-1.242 0-1.899.68-1.899 1.922v5.718c0 4.852 2.485 7.266 7.36 7.266m18.023-10.57v-2.555h-2.555v2.555Zm7.055 0v-2.555h-2.555v2.555Zm.305-12.961v-8.18c0-.562-.446-1.031-1.032-1.031H30.04c-.586 0-1.031.468-1.031 1.031v8.18c0 .562.445 1.008 1.03 1.008h8.157c.586 0 1.032-.446 1.032-1.008M18.812 18.8h6.141v6.14h-6.14Zm8.18 19.406v-8.18c0-.562-.445-1.007-1.031-1.007h-8.156c-.586 0-1.032.445-1.032 1.007v8.18c0 .563.446 1.031 1.032 1.031h8.156c.586 0 1.031-.468 1.031-1.031"/>
          </svg>
          <h1 className="mt-6 text-3xl font-extrabold text-[#6c584c]">Hey there! Welcome</h1>
          <p className="mt-3 text-lg text-gray-700">Scan your QR code to get started.</p>
        </div>
      </div>
    );
  }
  const renderFooter = (): JSX.Element => {
    const isSmallScreen = windowWidth <= 375;
    
    return (
      <footer style={{
        width: '100%',
        padding: isSmallScreen ? '15px 16px 25px' : '20px 20px 30px',
        textAlign: 'center',
        marginTop: 'auto',
      }}>
        <p style={{
          fontSize: isSmallScreen ? '11px' : '12px',
          fontFamily: 'DM Sans, sans-serif',
          color: 'var(--text-color)',
          lineHeight: 1.6,
          margin: 0,
          opacity: 0.8,
        }}>
          By proceeding, you agree with our{' '}
          <a 
            href="/customerPolicy.html" 
            style={{
              color: 'var(--main-turquoise)',
              textDecoration: 'underline',
              transition: 'color 0.2s ease',
              fontWeight: 500,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = 'var(--main-color)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = 'var(--main-turquoise)';
            }}
          >
            Privacy Policy
          </a>.
        </p>
      </footer>
    );
  };
  

  return (
    <div 
      id="screen" 
      style={{ 
        opacity,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #F6F9F9 0%, #FFFFFF 100%)',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {renderSlider()}
      {renderDots()}
      {renderDescription()}
      {renderButtons()}
      {renderFooter()}
    </div>
  );
};
